import Layout from '../../../components/Layout';
import { PoundSterling, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import wagoLogo from '../../../assets/wago-logo.png';

export default function Pricing() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Pricing</h1>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              Pricing calculators and tools
            </p>
          </div>
        </div>

        {/* Pricing Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Wago Price List Card */}
          <button
            onClick={() => navigate('/tenant/tools/pricing/wago-price-list')}
            className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 hover:border-blue-500 dark:hover:border-blue-500 hover:shadow-md transition-all text-left group"
          >
            <div className="flex items-start justify-between mb-4">
              <img 
                src={wagoLogo} 
                alt="Wago Logo" 
                className="h-16 w-auto object-contain"
              />
              <ExternalLink className="h-5 w-5 text-gray-400 dark:text-gray-500 group-hover:text-blue-500 transition-colors" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              Wago Current Price List
            </h3>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              View and manage Wago product pricing information
            </p>
          </button>
        </div>

        {/* Additional Content Placeholder */}
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-12">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="mb-6 p-4 bg-gray-100 dark:bg-gray-700 rounded-full">
              <PoundSterling className="h-12 w-12 text-gray-400 dark:text-gray-500" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
              More Pricing Tools Coming Soon
            </h2>
            <p className="text-xs text-gray-600 dark:text-gray-400 max-w-md">
              Additional pricing calculators and tools will be added here to help with your business pricing needs.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
